import { theme } from '@global-engineering-shared/gweb-material-theme-next';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    alignItems: 'center',
    columnGap: theme.spacing(0.5),
  },
  link: {
    color: theme.palette.primary.main,
    textDecoration: 'none',
  },
});

export default useStyles;
